import { RTYPE } from 'components/Dashboard/Analytics/ActivityLog/Dropdowns/TypesDropdown'

export interface DomainTestRequestData {
  resolverId: string
  domain: string
  rType: string
}

export interface AnswerRRs {
  NAME: string
  TYPE: number
  CLASS: number
  TTL: number
  TYPEname: RTYPE
  CLASSname: string
  rdataA?: string
  rdataAAAA?: string
  rdataCNAME?: string
}

export interface DomainTestResponseData {
  dateString: string
  dateSeconds: number
  ID: number
  QR: boolean
  RD: boolean
  RA: boolean
  QDCOUNT: number
  ANCOUNT: number
  QNAME: string
  QTYPE: number
  RCODE: number
  QTYPEname: string
  QCLASS: number
  QCLASSname: string
  answerRRs: AnswerRRs[]
  controld: {
    verdict: {
      verdictSource: string
      verdictAction: string
      verdictMatch: string
      verdictVia: string
    }
  }
}

export interface ReportBody {
  hostname: string
  filter: string
  message: string
}

export interface IncorrectLabelReportBody {
  domain: string
  feature: string
  field: string
  existingValue: string
  suggestedValue?: string
  reason?: string
}

export enum DnsSentinel {
  CLASSIFICATION = 'classification',
  DNS = 'dns',
  GEO_IP = 'geoip',
  HTTP = 'http',
  NET_LOG = 'netlog',
  SCREENSHOT = 'screenshot',
  TLS = 'tls',
  WHO_IS = 'whois',
}

export interface Record {
  ttl: number
  value: string
  priority: number
}

export interface Location {
  asn: string
  city: string
  country: string
  latitude: number
  longitude: number
  organization: string
}

export type Category = {
  confidence: number
  confidenceLabel: string
  id: number
  name: string
  reasoning: string
}

export type ClassificationData = {
  categories: Category[]
  collectedAt: string
  confidence: number
  reasoning: string
}

export type DnsData = {
  collectedAt: string
  records: { [key: string]: Record[] }
}

export type GeoIpData = {
  collectedAt: string
  ipLocations: {
    [key: string]: Location
  }
}

export type HttpData = {
  collectedAt: string
  contentLength: number
  contentType: string
  finalUrl: string
  redirects: string[]
  statusCode: number
}

export type NetLogData = {
  collectedAt: string
  topDomain: string
  total: number
  types: string[]
}

export type ScreenShotData = {
  collectedAt: string
  screenshotUrl: string
}

export type TlsData = {
  collectedAt: string
  issuer: string
  supportedProtocols: string
  validFrom: string
  validUntil: string
}

export type WhoIsData = {
  collectedAt: string
  parsed: {
    creationDate: string
    expirationDate: string
    lastUpdated: string
    registrant: {
      country: string
      email: string
      name: string
      organization: string
    }
    registrar: string
    raw: string
  }
}

export interface DnsSentinelResponseData {
  features: {
    [DnsSentinel.CLASSIFICATION]: ClassificationData | null
    [DnsSentinel.DNS]: DnsData | null
    [DnsSentinel.GEO_IP]: GeoIpData | null
    [DnsSentinel.HTTP]: HttpData | null
    [DnsSentinel.NET_LOG]: NetLogData | null
    [DnsSentinel.SCREENSHOT]: ScreenShotData | null
    [DnsSentinel.TLS]: TlsData | null
    [DnsSentinel.WHO_IS]: WhoIsData | null
  }
}

export interface CategoriesResponseData {
  categories: {
    [key: string]: {
      name: string
      sensitive: boolean
    }
  }
}
